import React, { useEffect } from "react";
import { connect } from "react-redux";
import { useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeft } from "@fortawesome/free-solid-svg-icons";
import { resetCheckout, fetchEcommerceConfig, fetchPaymentMethods, setCheckoutStep } from "../../redux/checkout/action";
import { toggleJWTModal } from "../../redux/authJWT/action";
import StepIndicator from "./components/StepIndicator";
import CartReview from "./components/CartReview";
import ShippingStep from "./components/ShippingStep";
import PaymentStep from "./components/PaymentStep";
import "./Checkout.page.css";

const STEP_TITLES = {
  1: "Carrello",
  2: "Spedizione",
  3: "Pagamento",
};

function CheckoutPage(props) {
  const navigate = useNavigate();
  const { step } = props.checkout;
  const { isAuthenticated, loadingProfile } = props.authJWT;

  // Carica la config e-commerce del tenant (abilitazione pickup/delivery, ecc.)
  useEffect(() => {
    props.fetchEcommerceConfig();
    props.fetchPaymentMethods();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Se il carrello viene svuotato durante il checkout, riporta allo step 1
  // (che mostra lo stato "carrello vuoto"). Evita di procedere con ordine a 0.
  const cartCount = props.groceryList.list.length;
  useEffect(() => {
    if (step > 1 && cartCount === 0) {
      props.setCheckoutStep(1);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [step, cartCount]);

  const handleBack = () => {
    props.resetCheckout();
    navigate("/leaflet");
  };

  return (
    <div className="co-page">
      <div className="co-topbar">
        <div className="co-topbar__left">
          <div className="co-topbar__back" onClick={handleBack}>
            <FontAwesomeIcon icon={faArrowLeft} />
          </div>
          <h1 className="co-topbar__title">{STEP_TITLES[step] || "Checkout"}</h1>
        </div>
      </div>

      <div className="co-layout">
        <div className="co-main">
          <StepIndicator currentStep={step} />

          {step === 1 && <CartReview />}
          {step === 2 && <ShippingStep />}
          {step === 3 && <PaymentStep />}
        </div>
      </div>
    </div>
  );
}

const mapStateToProps = (state) => ({
  checkout: state.checkout,
  authJWT: state.authJWT,
  groceryList: state.groceryList,
});

export default connect(mapStateToProps, {
  resetCheckout,
  toggleJWTModal,
  fetchEcommerceConfig,
  fetchPaymentMethods,
  setCheckoutStep,
})(CheckoutPage);
